import { React } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../../store/slices/modal/modalSlice";
import { deleteDriver } from "../../../store/slices/drivers/driverThunks";
const DeleteDriverModal = () => {
  const dispatch = useDispatch();


  const { drivers, index } = useSelector((state) => state.drivers);


  const deleteCredentials = () => {
    let body ={
        tenantid: drivers[index].idDriver
    }
    dispatch(deleteDriver(body))
    dispatch(closeModal());
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Delete Driver</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the {drivers[index].driverName} driver  ?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            dispatch(closeModal());
          }}
        >
          Close
        </Button>
        <Link to="/drivers">
          <Button variant="danger" onClick={() => deleteCredentials()}>
            Delete
          </Button>
        </Link>
      </Modal.Footer>
    </>
  );
};

export default DeleteDriverModal;
